import I18n from 'i18n-js';
import React from 'react';
import ReactDOMServer from 'react-dom/server';

export const SCORE_CONTAINER_CLASS_NAME = 'slide-show-score-variable';
export const SCORE_TITLE_CLASS_NAME = 'slide-show-score-variable-title';
export const SCORE_VALUE_CLASS_NAME = 'slide-show-score-variable-value';

type TotalSlideShowScoreHtmlType = {
  locale?: string;
  snippetNum?: number;
};

export const totalSlideShowScoreHtml = ({ locale, snippetNum } : TotalSlideShowScoreHtmlType): string => {
  const scoreString = '[score]';
  const pointsString = I18n.t('points', { locale }).toLowerCase();

  return ReactDOMServer.renderToString(
    <>
      &#8203;
      <span
        className={SCORE_CONTAINER_CLASS_NAME}
        contentEditable="false"
        data-text-variable-id={snippetNum}
      >
        <span className={SCORE_TITLE_CLASS_NAME}>
          {I18n.t('score', { locale })}:
        </span>
        <br />
        <span className={SCORE_VALUE_CLASS_NAME}>
          {scoreString}
          &nbsp;
          {pointsString}
        </span>
      </span>
      <br />
    </>,
  );
};

type TotalSlideShowScoreCallbackType = {
  e: React.MouseEvent<HTMLButtonElement>,
  editorInstance: any,
  htmlSnippets: {
    htmlEn: string,
    htmlEs: string,
  }
  locale: 'en' | 'es',
};

export const totalSlideShowScoreCallback = ({
  e,
  editorInstance,
  locale,
  htmlSnippets,
} : TotalSlideShowScoreCallbackType) => {
  e.preventDefault();
  e.stopPropagation();

  const html = locale === 'en' ? htmlSnippets.htmlEn : htmlSnippets.htmlEs;
  editorInstance.html.insert(html);
  editorInstance.undo.saveStep();
};

export const textVariableEnableEdit = (editorInstance: any) => {
  const editor = editorInstance.el as HTMLElement;
  if (!editor) return;

  const scoreElements = editor.querySelectorAll(`.${SCORE_CONTAINER_CLASS_NAME}`);
  scoreElements.forEach((element) => {
    element.setAttribute('contenteditable', 'true');
  });
};

export const textVariableDisableEdit = (editorInstance: any) => {
  const editor = editorInstance.el as HTMLElement;
  if (!editor) return;

  const scoreElements = editor.querySelectorAll(`.${SCORE_CONTAINER_CLASS_NAME}`);
  scoreElements.forEach((element) => {
    element.setAttribute('contenteditable', 'false');
  });

  editorInstance.undo.saveStep();
};
